module.exports = __webpack_public_path__ + "assets/img/partner-p2.8034d8fd.png";